import { AutoMap } from '@automapper/classes';

export class SamplingPointEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    Address!: string;
    @AutoMap()
    City!: string;
    @AutoMap()
    ZipCode!: string;
}
